<template>
  <BaseTemplate :currentUser="currentUser">
    <div class="confirm-buy-point">
      <Title :jpn="t('コイン購入')" />
      <div class="box_area">
        <GrayBack class="box">
          <div class="_row over">
            <span>{{ t('購入コイン') }}</span>
            <span class="point">{{dispPoint}}</span>
          </div>
          <div class="_row over">
            <span>{{ t('お支払い金額') }}</span>
            <span class="price">
              <span>&yen;</span>{{dispPrice}}
            </span>
          </div>
        </GrayBack>
        <GrayBack class="box">
          <div class="large_box">
            <SelectPayment
              v-if="payList"
              ref="selectPayment"
              class="select-payment"
              :paymentList="payList.list"
              :currentPaymentId="currentPaymentId"
              :errorMessageAccountHolder="errorMessageAccountHolder"
              :currentPointPrice="currentPointPrice"
              @handleRadioBtnClick="SelectPayment"
              @handleAccountHolderChange="accountHolderChange"
              @payPalOnApprove="payPalOnApprove"
            />
          </div>
        </GrayBack>
        <!-- <div class="carrer_memo">If you would like to pay with "Carrier billing, Merpay, LINE Pay, PayPay", you can also purchase at <a href="https://www.iranoan.com/blank-3/Point-for-Get24" target="_blank">minny</a> !</div> -->
        <div class="button_flex">
          <div class="button-area">
            <BuyButton
              class="purchase-btn square-button cancel-btn"
              :isArrow="false"
              :text="t('キャンセル')"
              @handleSquareBtnClick="cancelPayment"
            />
            <BuyButton
              v-if="isShowBuyBtn"
              class="purchase-btn square-button"
              :isArrow="false"
              :text="t('購入する')"
              @handleSquareBtnClick="makePayment"
            />
          </div>
        </div>
      </div>
    </div>
  </BaseTemplate>
</template>

<script defer language="javascript" :src="process.env.VUE_APP_PAYGENT_JS" charset="UTF-8"></script>
<script>
// index.htmlの読み込みも変える必要あり
import { mapGetters } from 'vuex';
import {
  separateCharacterNumber,
} from '@/common/util/format';

import BaseTemplate from '@/components/templates/BaseTemplate.vue';
import ShadowBox from '@/components/atoms/ShadowBox.vue';
import GrayBack from '@/components/molecules/GrayBack.vue';
import SelectPayment from '@/components/organisms/SelectPayment.vue';
import Title from '@/components/molecules/Title02.vue';
import t from '@/plugins/i18n';
import axios from 'axios';
import BuyButton from '@/components/atoms/BuyButton.vue';

export default {
  name: 'ConfirmBuyPoint',
  mixins: [t],

  components: {
    BaseTemplate,
    ShadowBox,
    SelectPayment,
    Title,
    GrayBack,
    BuyButton,
  },

  data: () => ({
    accountHolder: null,
    currentPaymentId: null,
    currentCombiniCode: 'econ',
    errorMessageAccountHolder: null,
  }),

  computed: {
    ...mapGetters({
      currentUser: 'user/currentUser',
      currentPointPrice: 'pointPrice/currentPointPrice',
      payList: 'pay/payList',
      buyPointResult: 'user/buyPointResult',
    }),
    dispPoint() {
      if (this.payList) {
        return separateCharacterNumber(this.payList.point);
      }
      return 0;
    },
    dispPrice() {
      if (this.payList) {
        return separateCharacterNumber(this.payList.price);
      }
      return 0;
    },
    isShowBuyBtn() {
      return this.currentPaymentId !== 3;
    }
  },

  watch: {
    currentPointPrice(newVal) {
      if (newVal) {
        this.$store.dispatch('pay/setPayList');
      }
    },
    payList(newVal) {
      if (newVal && newVal.list.length > 0) {
        this.currentPaymentId = newVal.list[0].id;
      }
    },
    buyPointResult(newVal) {
      if (newVal) {
        if (newVal.state === 200 && newVal.result === '1') {
          if (newVal.payment_id) {
            this.$router.push(`/confirm-combini?paymentID=${newVal.receipt_number}`);
          } else {
            if (newVal.url === '1') {
              alert(this.t('決済が成功し、ポイントに反映しました。'));
            }
            this.$store.dispatch('user/clearBuyPointResult');
            if (newVal.url.startsWith('http')) {
              this.$store.dispatch('setIsLoading', true);
              window.location.href = newVal.url;
            } else {
              this.$router.push(newVal.url);
            }
          }
        } else if (newVal.state === 200 && newVal.result === '7') {
          location.href = '/api/acs/secure';
        } else {
          if (this.currentPaymentId == 5) {
            if (this.$route.query.amazonCheckoutSessionId) {
              alert('Payment failed\nPlease check your Amazon Pay status')
            } else {
              alert('Payment failed\nPlease select Amazon Pay')
            }
          } else if (this.currentPaymentId == 3) {
            alert('Payment failed\nPlease check your PayPal status')
          } else {
            alert(this.t('決済が失敗しました。クレジットカードの状態をご確認ください。\n状態が不明な場合は、クレジットカード会社にお問い合わせください。'));
          }
          const { name } = newVal.errors;
          this.errorMessageAccountHolder = name ? name[0] : null;
        }
      }
    },
  },

  created() {
    const { pointPriceId } = this.$route.query;
    if (pointPriceId) {
      // pointPriceIdが存在すれば、選択されたpoint_priceをサーバーのsessionに格納、watchしているsetPayListでsessionに格納した値を取得。
      this.$store.dispatch('pointPrice/setCurrentPointPrice', { pointPriceId });
    } else {
      // pointPriceIdが存在しなければsessionに格納されているpoint_priceから呼び出す。
      this.$store.dispatch('pay/setPayList');
    }
  },

  methods: {
    SelectPayment(paymentId) {
      this.currentPaymentId = paymentId;
    },
    accountHolderChange(accountHolder) {
      this.accountHolder = accountHolder;
    },
    cancelPayment() {
      if (this.$route.query.packId) {
        const query = {
          packId: this.$route.query.packId,
        };
        this.$router.push({ path: '/buy-point', query });
        return;
      }
      this.$router.push('/buy-point');
    },
    makePayment() {
      if (this.currentPaymentId === 1) {
        const inputData = this.$refs.selectPayment.getData();
        if (`${inputData.card_index}` === '99999') {
          this.checkVeritrans();
        } else {
          const postParams = {
            pay_id: this.currentPaymentId,
            card_index: inputData.card_index,
          };
          this.$store.dispatch('user/buyPoint', { postParams });
        }
      } else if (this.currentPaymentId === 2) {
        const postParams = {
          pay_id: this.currentPaymentId,
          combini_code: this.currentCombiniCode,
        };
        this.$store.dispatch('user/buyPoint', { postParams });
      // } else if (this.currentPaymentId === 3) {
      //   const postParams = {
      //     pay_id: this.currentPaymentId,
      //   };
      //   this.$store.dispatch('user/buyPoint', { postParams });
      } else if (this.currentPaymentId === 4) {
        const postParams = {
          pay_id: this.currentPaymentId,
          name: this.accountHolder,
        };
        this.$store.dispatch('user/buyPoint', { postParams });
      } else if (this.currentPaymentId === 5) {
        const postParams = {
          pay_id: this.currentPaymentId,
        };
        this.$store.dispatch('user/buyPoint', { postParams });
      } else if (this.currentPaymentId === 6) {
        const postParams = {
          pay_id: this.currentPaymentId,
        };
        this.$store.dispatch('user/buyPoint', { postParams });
      } else if (this.currentPaymentId === 7) {
        const postParams = {
          pay_id: this.currentPaymentId,
        };
        this.$store.dispatch('user/buyPoint', { postParams });
      } else if (this.currentPaymentId === 8) {
        const postParams = {
          pay_id: this.currentPaymentId,
        };
        this.$store.dispatch('user/buyPoint', { postParams });
      } else if (this.currentPaymentId === 10) {
        const postParams = {
          pay_id: this.currentPaymentId,
        };
        this.$store.dispatch('user/buyPoint', { postParams });
      } else if (this.currentPaymentId === 11) {
        const postParams = {
          pay_id: this.currentPaymentId,
        };
        this.$store.dispatch('user/buyPoint', { postParams });
      }
    },
    checkVeritrans() {
      const inputData = this.$refs.selectPayment.getData();
      const param = {
        card_number:
          inputData.card_number + '',
        card_expire:
          ('0' + inputData.limit_month).slice(-2) + '/' +
          ('0' + inputData.limit_year).slice(-2),
        security_code: inputData.cvc,
        cardholder_name: inputData.card_name,
        token_api_key: process.env.VUE_APP_VERITRANS_TOKEN
      };

      const axiosCtrl = axios.create()
      axiosCtrl.post('https://api3.veritrans.co.jp/4gtoken', param).then(
        (res) => {
          if (res.data.code === 'success') {
            const postParams = {
              pay_id: this.currentPaymentId,
              token: res.data.token,
              req_card_number: res.data.req_card_number,
              card_user_name: param.cardholder_name,
            };
            this.$store.dispatch('user/buyPoint', { postParams });
          } else {
            alert(this.t('ご入力いただいたカード情報が確認できませんでした。\n再度ご入力内容をご確認ください。'))
          }
        }
      ).catch(
        (err) => {
          console.log(err)
          alert(this.t('ご入力いただいたカード情報が確認できませんでした。\n再度ご入力内容をご確認ください。'))
        }
      )
    },
    checkPaygent() {
      // const gID = '41161'; // マーチャントID(test)
      // const gKey = 'test_fc0XnocUcXteKklGeZsPbEqb'; // トークン生成鍵
      // const gID = process.env.VUE_APP_PAYGENT_ID; // マーチャントID(本番)
      // const gKey = process.env.VUE_APP_PAYGENT_KEY; // トークン生成鍵

      const inputData = this.$refs.selectPayment.getData();
      const paygentToken = new window.PaygentToken();
      paygentToken.createToken(
        process.env.VUE_APP_PAYGENT_ID, //第１引数︓マーチャントID
        process.env.VUE_APP_PAYGENT_KEY, //第２引数︓トークン生成鍵
        {
          card_number:
            inputData.card_number + '', //クレジットカード番号
          expire_year: inputData.limit_year, //有効期限-YY
          expire_month: inputData.limit_month, //有効期限-MM
          cvc: inputData.cvc, //セキュリティーコード
          name: inputData.card_name //カード名義
        }, this.paygent_step2 //︓コールバック関数(トークン取得後に実⾏)
      );
    },
    paygent_step2(response) {
      if (response.result == '0000') { //トークン処理結果が正常の場合
        const postParams = {
          pay_id: this.currentPaymentId,
          token: response.tokenizedCardObject.token,
          card_save: 1,
        };
        this.$store.dispatch('user/buyPoint', { postParams });
        // $('#card_token').val(response.tokenizedCardObject.token);
        // $('#card_fingerprint').val(response.tokenizedCardObject.fingerprint);
        // $('#card_masked_card_number').val(response.tokenizedCardObject.masked_card_number);
        // $('#card_token').val(response.tokenizedCardObject.token);
        // $('#card_valid_until').val(response.tokenizedCardObject.valid_until);
        // $('#card_hc').val(response.hc);
        //
        // $('#frm_order').submit();
      } else { //トークン処理結果が異常の場合
        var msg = "" ;
        if ( response.result=='1300' || response.result=='1301' ) msg=this.t("カード番号");
        if (response.result=='1400'
          || response.result=='1401'
          || response.result=='1500'
          || response.result=='1501'
          || response.result=='1502' ) msg=this.t("カード(年月)");
        if ( response.result=='1600' || response.result=='1601' ) msg=this.t("カード(セキュリティコード)");
        if ( response.result=='1700') msg=this.t("カード名義");
        if ( response.result=='8000') msg=this.t("システムメンテナンス");
        if ( response.result=='7001') msg=this.t("通信エラー");
        if ( msg=="" ) msg=this.t("その他");

        alert(msg + this.t('が不正です'));
      }
    },
    payPalOnApprove(modifiedDetails) {
      this.$store.dispatch('user/buyPoint', { postParams: modifiedDetails });
    },
  },
};
</script>

<style lang="scss" scoped>
.confirm-buy-point{
  width: 100%;
  max-width: 1000px;
  min-height: 100%;
  padding: 30px 24px 25px 24px;
  margin: 0 auto;
  text-align: center;
  // @include appendMap($backgroundStyleMap);
  .box_area {
    max-width: 680px;
    margin-left: auto;
    margin-right: auto;
    .box {
      display: flex;
      margin-top: 20px;
      margin-left: auto;
      margin-right: auto;
      // color: $white;
      flex-direction: column;
      max-width: 700px;
      padding: 10px 40px 20px 40px;
      ._row {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 5px 0 0 0;
        border-bottom: solid 1px $white;
        span {
          font-size: 18px;
        }
        .point {
          font-size: 28px;
          display: flex;
          justify-content: center;
          align-items: center;
          &:after {
            content: " Coin";
          }
          .price {
            color: $red;
            font-size: 24px;
            margin-bottom: 10px;
          }
        }
        .price {
          font-size: 26px;
        }
      }
    }
  }
  .large_box {
    margin-top: 20px;
  }
  .carrer_memo {
    width: 600px;
    margin: 20px auto 0 auto;
    // color: $white;
    font-size: 15px;
    // a {
    //   color: $white!important;
    // }
  }
  .point-value-area{
    margin-top: 30px;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    .shadow-box{
      display: flex;
      justify-content: center;
      align-items: center;
      width: 100%;
      height: 60px;
      margin-top: 5px;
      border-radius: 6px;
      font-family: $notoSerif;
      font-size: 30px;
      font-weight: 700;
      &.point{
        color: $deepGray;
        border: 1px solid $white;
      }
      &.value{
        color: $gold;
        border: 1px solid $gold;
      }
    }
    .text{
      display: inline-block;
      margin-top: 5px;
      font-family: $notoSans;
      font-size: 20px;
      font-weight: 500;
      // color: $white;
      line-height: 29px;
    }
  }
  .select-payment{
    margin-top: 10px;
  }
  .confirm.text{
    display: inline-block;
    margin-top: 30px;
    margin-bottom: 20px;
    font-family: $notoSans;
    font-size: 18px;
    // color: $white;
  }
  .button-area{
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 15px;
    .square-button{
      width: 200px;
      height: 40px;
      & + .square-button{
        margin-left: 30px;
      }
    }
  }
}
.button_flex {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  flex-direction: column;
}
.cancel-btn {
  background: $white;
  color: #9fa0a0;
}
@media screen and  (max-width: $tabletWidth) {
  .confirm-buy-point {
    padding: 30px 10px 25px 10px;
    .box_area {
      .box {
        padding: 20px 20px;
      }
    }
    .over {
      flex-wrap: wrap;
      span {
        &:nth-child(2) {
          margin-left: auto;
        }
      }
    }
    .button-area {
      flex-direction: column-reverse;

      .square-button {
        width: 200px;
        padding: 0;

        & + .square-button {
          margin-bottom: 10px;
          margin-left: 0;
        }
      }
    }
    .sp_hidden {
      display: none;
    }
    .carrer {
      padding: 6px 30px;
    }
    .carrer_memo {
      width: auto;
      font-size: 12px;
    }
  }
}
</style>
